export default {
    props: {
        label: {
            type: String,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        disabled: Boolean
    },
    data() {
        return {
            isActive: this.toggleActiveState()
        };
    },
    watch: {
        $route() {
            this.isActive = this.toggleActiveState();
        }
    },
    methods: {
        changeIndex() {
            this.$router.push({ 
                path: this.label === '#' ? '/index/number' : this.path 
            });
        },
        toggleActiveState() {
            return this.label === '#' 
                && this.$route.params.index === 'number' 
                || this.label === (this.$route.params.index || '');
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/BrowseByIndexPanel/BrowseLink/BrowseLink.js